<template>

    <p class="text-headline-small mb-4">Identificazione</p>

    <v-text-field label="Codice" v-model="properties.codice">
        <template v-slot:append>
            <v-btn size="" color="primary" @click="copy2clipboard(properties.codice)" class="pa-4"
            :disabled="!properties.codice"
            >
                <v-icon>mdi-content-copy</v-icon>
            </v-btn>
        </template>
    </v-text-field>

    <p class="text-headline-small mb-4">Rilievo</p>

    <v-select v-model="properties.tipo_id" label="Tipo" :items="tipo" item-title="label" class="" />

    <v-select v-model="properties.posa_id" label="Posa" :items="posa" item-title="label" />

    <v-select v-model="properties.manutenzione_id" label="Manutenzione" :items="manutenzione" item-title="label" />

    <SegnalazioneCommon v-model="properties" />
</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import baseData from '@/assets/catalog/TrackerForms.json'
import { onMounted } from 'vue'
import { useToastsStore } from "@/store/toasts";
import { useCopyToClipboard } from "@/service/copyToClipboard";

const properties = defineModel()
const toastsStore = useToastsStore();

const {copy2clipboard}  = useCopyToClipboard();


const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

const manutenzione= baseData.lookup.tabellazionemanutenzione
const posa= baseData.lookup.tabellazioneposa
const tipo= baseData.lookup.tabellazionetipo

const loadDefaults = () => {
    properties.value.label = "Tabellazione"
    properties.value.tipo_id = tipo[0].value
    properties.value.posa_id = posa[0].value
    properties.value.manutenzione_id = manutenzione[0].value
}



onMounted(() => {
  if (props.isNew) {
    loadDefaults()
  }
})
</script>
